import scope from "@/scope";export * from "@/scope";export default scope;